import { Button, ButtonA, ButtonCopy } from '../ButtonElement';
import React from 'react';
import AboutImage from '../../images/logo-szsem.png';
import ContactImage from '../../images/contact.svg';
import Support1PerImage from '../../images/support1Per.svg';
import SupportGiftImage from '../../images/supportGift.svg';
import { AboutContainer, AboutWrapper, AboutRow, Column1, TextWrapper, TopLine, Heading, Subtitle, BtnWrapper, Column2, ImgWrapper, Img, CopyTextAlert, CopyInput } from './AboutSectionElements'; 

const AboutSection = ({lightBg, id, imgStart, topLine, lightText, headLine, darkText, description, buttonLabel, img, to, outside, alt, primary, dark, dark2}) => {
    const copyBankNumber = () => {
        let text = document.getElementById('bankInput');
        text.select();
        text.setSelectionRange(0, 99999)
        document.execCommand("copy");
        const alertbox = document.getElementById('alertText');
        alertbox.style.top = '30px';

        setTimeout(() => {
            alertbox.style.top = '-100px';
        }, 2000);
    }

    return (
        <>
            <AboutContainer lightBg={lightBg} id={id}>
                <CopyTextAlert id="alertText">Numer konta został skopiowany</CopyTextAlert>
                <AboutWrapper>
                    <AboutRow imgStart={imgStart}>
                        <Column1>
                            <TextWrapper>
                                <TopLine>{topLine}</TopLine>
                                <Heading lightText={lightText}>{headLine}</Heading>
                                <Subtitle darkText={darkText}>
                                    {description}
                                    {id === 'support1Per' ? (
                                        <a href='https://salvatti.pl/'>https://salvatti.pl/</a>
                                    ) : ''}
                                </Subtitle>
                                <BtnWrapper>
                                    {id === 'supportGift' ? (
                                        <ButtonCopy onClick={copyBankNumber}>{buttonLabel}</ButtonCopy>
                                    ) : outside === 1 ? (
                                            <ButtonA href={to} smooth={true} duration={500} spy={true} exact="true" offset={-20} primary={primary ? 1 : 0} dark={dark ? 1 : 0} dark2={dark2 ? 1 : 0}>{buttonLabel}</ButtonA>
                                        ) : (
                                            <Button to={to} smooth={true} duration={500} spy={true} exact="true" offset={-80} primary={primary ? 1 : 0} dark={dark ? 1 : 0} dark2={dark2 ? 1 : 0}>{buttonLabel}</Button>
                                        )
                                    }
                                </BtnWrapper>
                            </TextWrapper>
                        </Column1>
                        <Column2>
                            <ImgWrapper>
                                <Img src={id === 'about' ? AboutImage : id === 'contact' ? ContactImage : id === 'support1Per' ? Support1PerImage : SupportGiftImage} alt={alt}/>
                            </ImgWrapper>
                        </Column2>
                    </AboutRow>
                </AboutWrapper>
                <CopyInput type="text" id="bankInput"  value="98 2030 0045 1110 0000 0387 2230" />
            </AboutContainer>
        </>
    )
}

export default AboutSection;
